export default __webpack_public_path__ + "static/media/leader_notes.e8921f36.pdf";